import React, { type ReactElement, useEffect, useRef, useState } from 'react'
import { Form, Input, Select, Switch } from 'antd'
import { connect, useDispatch } from 'react-redux'
import {
    type BussinessStateProps,
    type BussinessAddress,
} from '../../../../../../Types/Client/RegisteredClients/Corporate'
import commonStyles from '../../../../../../Utils/Common.less'
import { GetCountryList } from '../../../../../../Services/Common'
import PostCodeInput from '../../../../../../Components/PostCodeInput'
import { type ListFrontEndInterface } from '../../../../../../Types/CommonType'

const BussinessAddressForm = (props: BussinessAddress): ReactElement => {
    const { countryList, isEditing, toggleEditing, form } = props
    const [selectedCountry, setSelectedCountry] = useState<string>('')

    const dispatch = useDispatch()
    const hasFetchedOnce2 = useRef(false)
    const [address, setAddress] = useState({
        line_1: '',
        line_2: '',
        line_3: '',
        post_town: '',
        postcode: '',
        country: '',
    })
    useEffect(() => {
        const countryData = countryList?.find(
            (data: ListFrontEndInterface) =>
                data.label === address?.country?.toUpperCase()
        )
        if (address.line_1 !== '') {
            const AddressData = {
                busaddress1: address.line_1,
                busaddress2: address.line_2,
                bustown: address.post_town,
                buscountry: countryData?.label ?? '',
                buspostcode: address.postcode,
            }
            form.setFieldsValue(AddressData)
        }
    }, [address])
    useEffect(() => {
        if (!hasFetchedOnce2.current) {
            hasFetchedOnce2.current = true
            return
        }
        GetCountryList(dispatch)
    }, [])
    const handleCountryChange = (value: string): void => {
        setSelectedCountry(value)
        props.onDateChange(value)
    }

    return (
        <>
            <div className={commonStyles.bussinessToggle}>
                <Switch
                    size="small"
                    checked={isEditing}
                    onChange={toggleEditing}
                />
                <span className={commonStyles.bussinesToggleA}>
                    Same as Office
                </span>
            </div>
            <Form.Item
                label="Address 1"
                name="busaddress1"
                rules={[
                    {
                        required: true,
                        message: 'Please input your address one!',
                    },
                ]}
            >
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item label="Address 2" name="busaddress2">
                <Input allowClear maxLength={100} />
            </Form.Item>
            <Form.Item
                label="Town"
                name="bustown"
                rules={[
                    {
                        required: true,
                        message: 'Please input your town!',
                    },
                ]}
            >
                <Input allowClear maxLength={50} />
            </Form.Item>
            <Form.Item
                label="Country"
                name="buscountry"
                initialValue="UNITED KINGDOM"
            >
                <Select
                    key={countryList?.length}
                    allowClear
                    showSearch
                    onChange={handleCountryChange}
                    options={countryList?.map((country) => ({
                        value: country.label,
                        label: country.label,
                    }))}
                    value={selectedCountry}
                />
            </Form.Item>

            <PostCodeInput
                name="buspostcode"
                label="Post Code"
                reuireMessage="Please Enter Post Code"
                placeHolder={''}
                setAddressDetails={setAddress}
            />
        </>
    )
}

const mapStateToProps = (state: any): BussinessStateProps => {
    return {
        countryList: state.common.countryList,
        corporateTaps: state.client.corporateTaps,
    }
}

export default connect(mapStateToProps)(BussinessAddressForm)
